import { useState } from 'react';
import { Link } from 'react-router-dom';
import { LogoFull } from '../components/Logo';
import { api } from '../api/client';

export default function ForgotPassword() {
  const [email, setEmail]       = useState('');
  const [loading, setLoading]   = useState(false);
  const [success, setSuccess]   = useState(false);
  const [error, setError]       = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await api.auth.forgotPassword(email);
      setSuccess(true);
    } catch (err) {
      setError(err.message || 'Something went wrong.');
    } finally {
      setLoading(false);
    }
  };

  const s = styles;

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.logo}><LogoFull /></div>
        <h1 style={s.title}>Forgot password?</h1>
        {success ? (
          <div>
            <div style={s.successBox}>
              Check your email — if that address is registered, we've sent a reset link. It expires in 1 hour.
            </div>
            <Link to="/login" style={s.backLink}>← Back to login</Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <p style={s.sub}>Enter your email address and we'll send you a link to reset your password.</p>
            {error && <div style={s.errorBox}>{error}</div>}
            <label style={s.label}>Email address</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              style={s.input}
              placeholder="you@example.com"
              required
              autoFocus
            />
            <button type="submit" style={s.btn} disabled={loading}>
              {loading ? 'Sending...' : 'Send reset link'}
            </button>
            <Link to="/login" style={s.backLink}>← Back to login</Link>
          </form>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: { minHeight: '100vh', background: '#17171e', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' },
  card: { background: '#1a1a24', border: '1px solid #2a2a38', borderRadius: 16, padding: '40px', width: '100%', maxWidth: 420 },
  logo: { marginBottom: 28, display: 'flex', justifyContent: 'center' },
  title: { fontSize: 24, fontWeight: 800, fontFamily: 'Syne, sans-serif', color: '#f0f0f4', margin: '0 0 8px' },
  sub: { fontSize: 14, color: '#7a7a94', margin: '0 0 24px', lineHeight: 1.6 },
  label: { display: 'block', fontSize: 13, fontWeight: 600, color: '#b0b0c4', marginBottom: 6 },
  input: { width: '100%', padding: '10px 14px', background: '#17171e', border: '1px solid #2a2a38', borderRadius: 8, color: '#f0f0f4', fontSize: 15, marginBottom: 18, boxSizing: 'border-box', outline: 'none', fontFamily: 'DM Sans, sans-serif' },
  btn: { width: '100%', padding: '12px', background: '#FFD93D', color: '#1a1a24', border: 'none', borderRadius: 8, fontWeight: 700, fontSize: 15, fontFamily: 'Syne, sans-serif', cursor: 'pointer', marginBottom: 16 },
  backLink: { display: 'block', textAlign: 'center', fontSize: 14, color: '#7a7a94', textDecoration: 'none', marginTop: 8 },
  successBox: { background: 'rgba(82,255,138,0.08)', border: '1px solid rgba(82,255,138,0.2)', borderRadius: 8, padding: '14px 16px', color: '#52ff8a', fontSize: 14, lineHeight: 1.6, marginBottom: 20 },
  errorBox: { background: 'rgba(255,82,82,0.08)', border: '1px solid rgba(255,82,82,0.2)', borderRadius: 8, padding: '14px 16px', color: '#ff5252', fontSize: 14, marginBottom: 16 },
};
